/* Stylesheet */

.filter_container {
  position: absolute;
  top: -8px;
  right: 38px;
  max-height: 221px;
  min-height: 138px;
  min-width: 132px;
  border-radius: 4px;
  color: var(--ion-color-text-secondary);
  background: var(--ion-gradient-dark-transparent);
  overflow: hidden;
  box-shadow: var(--ion-box-shadow);
  z-index: 1000;

  .label {
    padding: 0px 21px 0px 21px;
    margin: 0px 8px 0px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 46px;
    font-size: 1rem;
    font-weight: 500;
    border-bottom: 1px solid #ffffff;
  }

  .wrapper_container {
    max-height: 138px;
    overflow: auto;
  }
}
